import groq from 'groq';
import { getConfig } from '@/constants/config';
import { sanityFetch } from '@/integrations/sanity/client';
import type { NOTICES_QUERY_RESULT } from '@/integrations/sanity/sanity.types';

const NOTICES_QUERY = groq`*[_type == 'notice' && country == $country]{
  _id,
  title,
  content,
  severity,
  pagesShown
}`;

export const getNotices = () =>
  sanityFetch<NOTICES_QUERY_RESULT>(NOTICES_QUERY, { country: getConfig().country });
